import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import { kycRoute } from '../lib/kyc';

// Smart redirector: inspects the REAL backend KYC state and sends the merchant to the correct step.
export default function OnboardingPage() {
  const { api } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/merchants/me/kyc/status');
        navigate(r.data.route || kycRoute(r.data.status), { replace: true });
      } catch {
        navigate('/kyc', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center text-muted-foreground" data-testid="onboarding-redirect">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> Checking your onboarding status…
    </div>
  );
}
